import * as i0 from '@angular/core';
import { NgModule, Injectable, Inject } from '@angular/core';
import * as i2 from '@angular/common/http';
import { HttpParams } from '@angular/common/http';
import * as i1 from '@usana/ux/translations';
import { REST_URL_TRANSLATION } from '@usana/ux/translations';

class UsanaTranslationsPdfModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UsanaTranslationsPdfModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: UsanaTranslationsPdfModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UsanaTranslationsPdfModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: UsanaTranslationsPdfModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class TranslationPdfService {
    constructor(translationConfig, http, restUri = '') {
        this.translationConfig = translationConfig;
        this.http = http;
        this.restUri = restUri;
    }
    /**
     * Translates the specified tags and generates a PDF blob
     */
    translateAsPdf(pkg, titleTag, bodyTags, verification = true) {
        // build a URL: /i18n/pdf?localeId=enu-US&pkg=dotcom&tags=asdf.body&titleTag=asdf.title&verify=false
        const params = new HttpParams({
            fromObject: {
                localeId: this.translationConfig.getMarketId(),
                pkg: pkg,
                tags: bodyTags,
                titleTag: titleTag,
                verify: verification + '',
            },
        });
        return this.http
            .get(this.restUri + '/pdf', {
            params: params,
            responseType: 'blob',
            observe: 'response',
        })
            .toPromise();
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TranslationPdfService, deps: [{ token: i1.TranslationConfig }, { token: i2.HttpClient }, { token: REST_URL_TRANSLATION }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TranslationPdfService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: TranslationPdfService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.TranslationConfig }, { type: i2.HttpClient }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [REST_URL_TRANSLATION]
                }] }] });

/**
 * Generated bundle index. Do not edit.
 */

export { TranslationPdfService, UsanaTranslationsPdfModule };
